import type { ProjectScope } from './project-scope';

const pendingFlyCueWriteKeys = new Set<string>();

function flyCueWriteKey(scope: ProjectScope, cueId: string): string {
    return `${scope.orgId}/${scope.projectId}/${cueId}`;
}

export function markPendingFlyCueWrite(scope: ProjectScope, cueId: string): void {
    pendingFlyCueWriteKeys.add(flyCueWriteKey(scope, cueId));
}

export function clearPendingFlyCueWrite(scope: ProjectScope, cueId: string): void {
    pendingFlyCueWriteKeys.delete(flyCueWriteKey(scope, cueId));
}

export function isPendingFlyCueWrite(scope: ProjectScope, cueId: string): boolean {
    return pendingFlyCueWriteKeys.has(flyCueWriteKey(scope, cueId));
}

export function clearPendingFlyCueWrites(): void {
    pendingFlyCueWriteKeys.clear();
}
